import React from 'react';
import { PlusCircleFill } from 'react-bootstrap-icons';
import ReactTooltip from 'react-tooltip';

interface AddAssignToCircleButtonProps {
  onClick: (e: React.MouseEvent<SVGElement, MouseEvent>) => void;
  recommended?: boolean;
  tooltipPlace?: 'top' | 'bottom' | 'left' | 'right';
}
const AddAssignToCircleButton = ({
  onClick,
  recommended,
  tooltipPlace,
}: AddAssignToCircleButtonProps) => {
  const iconSize = 18;
  const outerCircleSize = 32;
  const innerCircleSize = 26;
  const outerStyle = React.useMemo(
    () => ({
      width: `${outerCircleSize}px`,
      height: `${outerCircleSize}px`,
      backgroundColor: '#B2CEE2',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
    }),
    [outerCircleSize],
  );

  const innerStyle = React.useMemo(
    () => ({
      width: `${innerCircleSize}px`,
      height: `${innerCircleSize}px`,
      borderRadius: '50%',
      backgroundColor: '#fff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }),
    [innerCircleSize],
  );

  return recommended ? (
    <>
      <ReactTooltip
        id="recommended-assign-patient"
        effect="solid"
        place={tooltipPlace}
      >
        <div className="mb-1">Recommended for your list</div>
      </ReactTooltip>
      <div style={outerStyle} data-for="recommended-assign-patient" data-tip>
        <div style={innerStyle}>
          <PlusCircleFill
            color="#5C6469"
            size={iconSize}
            className="clickable"
            onClick={onClick}
          />
        </div>
      </div>
    </>
  ) : (
    <PlusCircleFill
      color="#5C6469"
      size={iconSize}
      className="clickable"
      onClick={onClick}
    />
  );
};

export default AddAssignToCircleButton;
